import {Injectable} from '@angular/core';
import {HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {delay, finalize, tap} from "rxjs";
import {ToastService} from '../services/toast.service';
import {ErrorResponse} from '../services/models/error-response';

export const HideLoading = 'X-Skip-Interceptor';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  private _totalReq: number = 0;

  constructor(private _toastService: ToastService) {
  }

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): any {
    this._totalReq++;
    const isLoadingEnabled: boolean = !request.headers.has(HideLoading);

    const token: string | null = sessionStorage.getItem('token');
    const cloneRequest = request.clone({
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'Access-Control-Allow-Origin': '*'
      }),
    });

    let requestHandled;

    requestHandled = next.handle(cloneRequest).pipe(
      delay(!isLoadingEnabled ? 0 : 500),
      tap({
        next: () => {
        },
        error: async (errorHttpResponse: any) => {
          await this.httpErrors(errorHttpResponse);
        }
      }),
      finalize(() => {
        this._totalReq--;
      })
    );

    return requestHandled;
  }

  public async httpErrors(httpResponse: any): Promise<void> {
    switch (httpResponse.status) {
      /**
       * Unauthorized
       */
      case 401:
        this._toastService.toastWarning(
          'Não autorizado. Por favor, realize o Login e tente novamente.'
        );
        // await this._authService.logout();
        break;
      /**
       * Forbidden
       */
      case 403:
        this._toastService.toastWarning(
          'Método não autorizado. Por favor, tente novamente.'
        );
        break;
      /**
       * Bad Request
       */
      case 400:
        let errorMessage = 'Requisição inválida';
        if ((httpResponse.error && Array.isArray(httpResponse.error))) {
          httpResponse.error.forEach((error: ErrorResponse) => {
            this._toastService.toastWarning(error.message);
          })
        } else if (httpResponse.error?.errors) {
          httpResponse.error?.errors.forEach((error: ErrorResponse) => {
            this._toastService.toastWarning(error.message);
          })
        } else {
          this._toastService.toastWarning(
            errorMessage
          );
        }

        break;
      /**
       * Internal Server Error
       */
      case 500:
        if (httpResponse.error?.errors) {
          for (let i = 0; i < httpResponse.error.errors?.length; i++) {
            this._toastService.toastError(httpResponse.error.errors[i]);
          }
        } else {
          this._toastService.toastError(
            'Erro interno do servidor. Por favor, tente novamente mais tarde.'
          );
        }
        break;
      default:
        this._toastService.toastError(
          'Ocorreu um erro inesperado. Por favor, tente mais tarde: ' + (httpResponse.error?.message || '')
        );
    }
  }
}
